var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
const baseUrl = '/service_trade';
// Validate ServiceTrade credentials and preview connection
export function validateCredentials(username, password) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.post(`${baseUrl}/validate_credentials`, {
                username,
                password
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error validating ServiceTrade credentials:', error);
            let errorMessage = 'Failed to validate credentials';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Connect ServiceTrade account
export function connect(username, password, vendorId, officeIds, authToken) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.post(`${baseUrl}/connect`, {
                username,
                password,
                vendor_id: vendorId,
                office_ids: officeIds,
                auth_token: authToken
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error connecting to ServiceTrade:', error);
            let errorMessage = 'Failed to connect to ServiceTrade';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Update selected offices
export function updateOffices(officeIds) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.post(`${baseUrl}/update_offices`, {
                office_ids: officeIds
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating offices:', error);
            let errorMessage = 'Failed to update offices';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Trigger manual sync
export function triggerSync(officeIds) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.post(`${baseUrl}/trigger_sync`, {
                office_ids: officeIds
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error triggering sync:', error);
            let errorMessage = 'Failed to trigger sync';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Get SQS queue status
export function getQueueStatus() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.get(`${baseUrl}/queue_status`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching queue status:', error);
            let errorMessage = 'Failed to fetch queue status';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Update ServiceTrade settings
export function updateSettings(settings) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            yield api.patch(`${baseUrl}/update`, {
                tenant: settings
            });
            return {
                data: undefined
            };
        }
        catch (error) {
            console.error('Error updating ServiceTrade settings:', error);
            let errorMessage = 'Failed to update settings';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Disconnect from ServiceTrade
export function disconnect() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.delete(`${baseUrl}/disconnect`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error disconnecting from ServiceTrade:', error);
            let errorMessage = 'Failed to disconnect from ServiceTrade';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Get webhook status
export function getWebhookStatus() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.get(`${baseUrl}/webhook_status`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching webhook status:', error);
            let errorMessage = 'Failed to check webhook status';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Setup webhook
export function setupWebhook() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.post(`${baseUrl}/setup_webhook`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error setting up webhook:', error);
            let errorMessage = 'Failed to setup webhook';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Remove webhook
export function removeWebhook() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const response = yield api.delete(`${baseUrl}/remove_webhook`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error removing webhook:', error);
            let errorMessage = 'Failed to remove webhook';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                errorMessage = ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || errorMessage;
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Export default object with all functions
export default {
    validateCredentials,
    connect,
    updateOffices,
    triggerSync,
    getQueueStatus,
    updateSettings,
    disconnect,
    getWebhookStatus,
    setupWebhook,
    removeWebhook
};
